import { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Stack,
  TextField,
} from "@mui/material";

interface AgeGroupMultiInputProps {
  value: string[];
  onChange: (v: string[]) => void;
}

export const AgeGroupMultiInput = ({
  value,
  onChange,
}: AgeGroupMultiInputProps) => {
  const [input, setInput] = useState("");

  const add = () => {
    const v = input.trim();
    if (!v) return;
    onChange([...(value || []), v]);
    setInput("");
  };

  const remove = (idx: number) => {
    const next = [...(value || [])];
    next.splice(idx, 1);
    onChange(next);
  };

  return (
    <Box sx={{ border: 1, borderColor: "divider", p: 2, borderRadius: 2 }}>
      <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
        <TextField
          size="small"
          placeholder="e.g., 9-11"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          fullWidth
        />
        <Button variant="outlined" onClick={add}>
          Add
        </Button>
      </Stack>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        {(value || []).map((g, i) => (
          <Chip key={i} label={g} onDelete={() => remove(i)} size="small" />
        ))}
      </Stack>
    </Box>
  );
};
